import React, { useContext } from 'react'
import styled from '@emotion/styled'
import { Form } from 'react-final-form'

// context
import { RfqContext } from '@duplo/components/lib/RfqProvider'

// utils
import { zipPrefillDecorator } from '@duplo/core/lib/form'
import { createHandleSubmitOrNext } from '@duplo/core/lib/flow'
import { isBrowser } from '@duplo/utils/lib/browser'

// common components
import { AdvertisingDisclosure } from '@duplo/components/lib/AdvertisingDisclosure'
import BaseEsDataTracker from '@duplo/components/lib/BaseEsDataTracker'
import Cta from '@duplo/components/lib/Cta'
import CtaWithArrow from '@duplo/components/lib/Cta/ArrowLayoutLegacy'
import Footer from '@duplo/components/lib/Footer'
import Header from '@duplo/components/lib/Header'
import MotivationCalculator from '@duplo/components/lib/MotivationCalculator'
import Navigation from '@duplo/components/lib/Navigation'
import OfflineNotifier from '@duplo/components/lib/OfflineNotifier'
import ProgressBar from '@duplo/components/lib/ProgressBar'
import ProgressCalculator from '@duplo/components/lib/ProgressCalculator'
import QuestionSet from '@duplo/components/lib/QuestionSet'
import SeoHelmet from '@duplo/components/lib/SeoHelmet'
import SpinnerOverlay from '@duplo/components/lib/SpinnerOverlay'
import Tcpa from '@duplo/components/lib/Tcpa'

import bcBackground from './bcBackground.png'

// styled components
const QuestionSetWrapper = styled.div`
	margin: 0 auto;
	max-width: ${({ theme }) => theme.maxWidths.S};
	overflow: hidden;
`

const TemplateContainer = styled.div`
	background-color: #f9f7f5;
`

const FlexWrap = styled.div`
	display: flex;
	justify-content: flex-start;
	margin: 0 auto;
	max-width: ${({ theme }) => theme.maxWidths.L};

	${({ theme }) => theme.mq.L} {
		justify-content: space-between;
	}
`

const BodyWrapper = styled.div`
	${({ theme }) => theme.mq.L} {
		background: url(${(props) => props.productImage}) no-repeat, url(${bcBackground}) repeat-x;
		background-position: center top;
		padding-bottom: 50px;
	}
`

const QsForm = styled.form`
	background-color: #e2e2e2;
	margin-bottom: 0;
	user-select: none;
	width: 100%;

	${({ theme }) => theme.mq.L} {
		border: 3px solid black;
		margin-top: -3px;
		max-width: ${({ theme }) => theme.maxWidths.XS};
	}
`

const NoDisplayOnLarge = styled.div`
	${({ theme }) => theme.mq.L} {
		display: none;
	}
`

const NoDisplayOnSmallAndMedium = styled.div`
	display: none;

	${({ theme }) => theme.mq.L} {
		display: block;
	}
`
const TESTING = styled.div`
	text-align: center;
	font-size: x-large;
	font-weight: 800;
	color: #1a214e;
    background: #fff57b;
}
`
function BlueCrushView() {
	const rfqContext = useContext(RfqContext)
	const {
		initialFormValues,
		isLoadingGlobal,
		categoryData: { altImage1 },
	} = rfqContext
	const dataLotTest = isBrowser() ? window.location.search.includes('datalot') : false;
	return (
		<TemplateContainer>
			
			
			<SeoHelmet />

			<OfflineNotifier />

			<Header />

			<NoDisplayOnLarge>
				<ProgressCalculator>{(progressCalcProps) => <ProgressBar {...progressCalcProps} />}</ProgressCalculator>
			</NoDisplayOnLarge>

			<BodyWrapper productImage={altImage1}>
				
				<FlexWrap>
					<NoDisplayOnSmallAndMedium>
						<CtaWithArrow />
					</NoDisplayOnSmallAndMedium>
					
					<Form
						decorators={[zipPrefillDecorator]}
						initialValues={initialFormValues}
						onSubmit={createHandleSubmitOrNext(rfqContext)}
					>
						
						{({ handleSubmit, submitting }) => (
							<QsForm onSubmit={handleSubmit}>
								<QuestionSetWrapper>
								{dataLotTest && <TESTING>TESTING</TESTING>}
									<QuestionSet handleSubmitOrNext={handleSubmit} />
									<AdvertisingDisclosure />
								</QuestionSetWrapper>

								<Navigation isSubmitting={submitting} />

								<NoDisplayOnSmallAndMedium>
									<ProgressCalculator>
										{({ percentCompleted, nextPercentValue }) => (
											<MotivationCalculator
												nextPercentValue={nextPercentValue}
												percentCompleted={percentCompleted}
											>
												{(progressCalcProps) => <ProgressBar {...progressCalcProps} />}
											</MotivationCalculator>
										)}
									</ProgressCalculator>
								</NoDisplayOnSmallAndMedium>

								<NoDisplayOnSmallAndMedium>
									<Tcpa />
								</NoDisplayOnSmallAndMedium>
							</QsForm>
						)}
					</Form>
				</FlexWrap>
			</BodyWrapper>
			<NoDisplayOnLarge>
				<Tcpa />
			</NoDisplayOnLarge>

			<Cta />

			<Footer />

			{isLoadingGlobal && <SpinnerOverlay />}

			<BaseEsDataTracker />
		</TemplateContainer>
	)
}

export default BlueCrushView
